module.exports = __webpack_public_path__ + "components/MapControl/svg/Szlak Nordic Walking czarny.svg?323ed953";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szlak Nordic Walking czarny.svg
// module id = 2115
// module chunks = 0